import { render } from "./SectionSSV.vue?vue&type=template&id=9ff9f32c&scoped=true"
import script from "./SectionSSV.vue?vue&type=script&lang=js"
export * from "./SectionSSV.vue?vue&type=script&lang=js"

import "./SectionSSV.vue?vue&type=style&index=0&id=9ff9f32c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff9f32c"]])

export default __exports__